import { render } from "./product-item.vue?vue&type=template&id=021274c4&scoped=true&ts=true"
import script from "./product-item.vue?vue&type=script&lang=ts"
export * from "./product-item.vue?vue&type=script&lang=ts"

import "./styles/product-item.scss?vue&type=style&index=0&id=021274c4&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021274c4"]])

export default __exports__